import React, { useState, useEffect } from 'react';
import './Preloader.css';

const Preloader = () => {
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const duration = 1200;
    let startTime;
    let frameId;

    const animateProgress = (timestamp) => {
      if (!startTime) {
        startTime = timestamp;
      }

      const elapsedTime = timestamp - startTime;
      const newProgress = Math.min((elapsedTime / duration) * 100, 100);
      setProgress(newProgress);

      if (elapsedTime < duration) {
        frameId = requestAnimationFrame(animateProgress);
      } else {
        setLoading(false);
      }
    };

    frameId = requestAnimationFrame(animateProgress);

    return () => {
      cancelAnimationFrame(frameId);
    };
  }, []);

  return (
    <>
      {loading && (
        <div className="art-preloader">
          <h4>Mikhail Pak</h4>
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div style={{ marginTop: '20px' }}>{Math.round(progress)}%</div>
        </div>
      )}
    </>
  );
};

export default Preloader;
